// app/src/runtime-config.ts
// Runtime config used by legacy UI panels (e.g., SuSuActionsPanel).
// Best-practice: runtime injection is authoritative; defaults must NOT drift to devnet.

declare global {
  interface Window {
    __WEARE_SUSU_RUNTIME_CONFIG__?: {
      APP_ENV?: string;
      endpoint?: string;
      programId?: string;
      PHASE?: string;
      LOG_LEVEL?: string;
      UPDATED_AT?: string;
    };

    // legacy fallbacks (keep for compatibility)
    __WEARE_SUSU_RUNTIME__?: any;
    __WEARE_SUSU_CONFIG__?: any;
    _CONFIG__?: any;
  }
}

type RuntimeConfig = {
  APP_ENV?: string;
  endpoint?: string;
  programId?: string;
};

function readRuntime(): RuntimeConfig {
  const w = typeof window !== "undefined" ? (window as any) : {};
  return (
    w.__WEARE_SUSU_RUNTIME_CONFIG__ ||
    w.__WEARE_SUSU_RUNTIME__ ||
    w.__WEARE_SUSU_CONFIG__ ||
    w._CONFIG__ ||
    {}
  );
}

function norm(v: unknown) {
  return String(v ?? "").trim();
}

export const SOLANA_ENDPOINT: string = (() => {
  const rt = readRuntime();
  const ep = norm(rt.endpoint);
  // Default must be TESTNET to prevent accidental cluster drift.
  return ep || "https://api.testnet.solana.com";
})();

export const PROGRAM_ID: string = (() => {
  const rt = readRuntime();
  const pid = norm(rt.programId);
  // Keep as last-resort fallback only.
  return pid || "5bf9hRQ81Mnun8SDUfkanRL7hyCwBycBQLwhcZgkPJsd";
})();

export const APP_ENV: string = (() => {
  const rt = readRuntime();
  const env = norm(rt.APP_ENV).toLowerCase();
  return env || "testnet";
})();

export function __runtimeDebug() {
  const rt = readRuntime();
  return {
    runtime: rt,
    resolved: {
      APP_ENV,
      endpoint: SOLANA_ENDPOINT,
      programId: PROGRAM_ID,
    },
  };
}
